<template lang="pug">
  .report-template-list
    report-template(v-for="template in reportTemplates" key="id"
      :template="template" :isEditing="!template.id")
    footer
      .actions
        b-button(@click.stop.prevent="addNewTemplate" size="sm" variant="success") Add Template
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import reportTemplate from '@/components/report-template'

export default {
  name: 'report-template-list',
  components: { reportTemplate },
  computed: {
    ...mapState(['reportTemplates', 'allReports'])
  },
  methods: {
    ...mapMutations(['addNewTemplate'])
  }
}

</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// report-template-list.vue?2ff432ad